import { render, staticRenderFns } from "./campaignTablePlan.vue?vue&type=template&id=6f60ae3f&scoped=true&"
import script from "./campaignTablePlan.vue?vue&type=script&lang=js&"
export * from "./campaignTablePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60ae3f",
  null
  
)

export default component.exports